import React, { Component } from "react";
import Image from '../global/Image';

export default class InfoImage extends Component {
  	
	render() {
		
		const post = this.props.post; 
		
		return (
			
			<div className="c-info__section c-info__section--medium-space c-load">
			
				<div className="l-content">
			
					<div className="l-grid">
					
						<div className="l-grid__col l-grid__col--m-6-12 l-grid__col--m-push-3-12 l-grid__col--l-5-12 l-grid__col--l-push-7-24">
							
							{post.hero_src &&
								
								<div className="c-info__image">
										
									<Image width={post.hero_width} height={post.hero_height} srcset={post.hero_srcset} src={post.hero_src} />
															
								</div>
							
							}
							
						</div>
					
					</div>
					
				</div>
			
			</div>
			
		)
		
	}
							
}